// extracted by mini-css-extract-plugin
module.exports = {"polygon":"a2c79c7e7d--polygon--AKTrX","polygon-active":"a2c79c7e7d--polygon-active--Pk4Bu"};